import {AxiosResponse} from 'axios';
import HttpRequest from '@/services/http-request';

export const getCatalogCFDIUses = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/cfdi_uses');

export const getCatalogExports = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/exports');

export const getCatalogPaymentForms = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/payment_forms');

export const getCatalogPaymentMethods = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/payment_methods');

export const getCatalogSATKeys = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/sat_keys');

export const getCatalogTaxObjects = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/tax_objects');

export const getCatalogTaxRegimes = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/tax_regimes');

export const getCatalogTaxes = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/taxes');

export const getCatalogUnits = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/units');

export const getCatalogVatRates = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/vat_rates');

export const getCatalogVatTaxes = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/vat_taxes');

export const getCatalogConceptPayments = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/concept_payments');

export const getCatalogCurrenccies = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/invoice/get/currencies');